import React from "react";
import AppHeader from "../../../components/Header/Header";
import AppLayout from "../../../components/layout";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Pagination from 'react-bootstrap/Pagination';
import { Link } from 'react-router-dom';


export default function noticia(){
const NoticiaData = [
  {
    id: 1,
    link: '/jornadacientifica',
    image: require('../../../assets/Not_14.jpg'),
    title: 'CURSO PREPARATÓRIO ISPA para acesso Ano Lectivo 2025-2026',
    subtitle: 'Invista em conhecimento, habilidades e oportunidades, transformando sua carreira com a melhor preparação para o acesso ao ensino superior. Estamos aqui para te ajudar a alcançar o sucesso que sempre sonhou.'
  },
  {
    id: 2,
    link: '# ',
    image: require('../../../assets/Not_15_Capa.jpg'),
    title: 'Brasil e Angola unidos por laços espirituais e acadêmicos: Visita do Reverendo Sérgio ao ISPA Atlântida',
    subtitle: 'ISPA Atlântida e Instituto Azusa fortalecem laços acadêmicos e espirituais em encontro histórico marcado por homenagens e diálogo construtivo.'
  },
  {
    id: 3,
    link: '#',
    image: require('../../../assets/Not_16.jpg'),
    title: 'O Seu Futuro Profissional Merece o Melhor',
    subtitle: 'Com a formação certa, você está a um passo de transformar seus sonhos em realidade. Invista em você, aprenda com os melhores e prepare-se para um futuro de sucesso. Estamos aqui para te ajudar a alcançar o topo.'
  },

]
const worksDataSecound = [
  {
    id: 4,
    link: '/jornadacientifica',
    image: require('../../../assets/Not_01.jpg'),
    title: 'Educação e Formação Científica',
    subtitle: 'A Pesquisa como Caminho para o Conhecimento. A Jornada Científica é um espaço dedicado à promoção do conhecimento, da investigação e da inovação'
  },
  {
    id: 5,
    link: '#',
    image: require('../../../assets/Not_02.jpg'),
    title: 'Formação de Qualidade para um Futuro Brilhante',
    subtitle: 'Prepare-se para os desafios do mercado de trabalho com a melhor educação. Aqui, você encontra o suporte, o conhecimento e as ferramentas necessárias para alcançar grandes conquistas.'
  },
  {
    id: 6,
    link: '#',
    image: require('../../../assets/Not_03.jpg'),
    title: 'O Seu Futuro Profissional Merece o Melhor',
    subtitle: 'Com a formação certa, você está a um passo de transformar seus sonhos em realidade. Invista em você, aprenda com os melhores e prepare-se para um futuro de sucesso. Estamos aqui para te ajudar a alcançar o topo.'
  },
  {
    id: 7,
    link: '#',
    image: require('../../../assets/Not_05.jpg'),
    title: 'Palestra  sobre a violencia Domestica',
    subtitle: 'Na palestra sobre a violência doméstica, realizada em uma data não especificada, especialistas e ativistas se reuniram para discutir esse tema crucial. Durante o evento, foram abordadas questões como prevenção, suporte às vítimas e mudança de paradigmas culturais.'
  },
  {
    id: 8,
    link: '#',
    image: require('../../../assets/Not_06.jpg'),
    title: 'Lançamento da ROC- Revista Olhar Científico',
    subtitle: 'No lançamento da ROC - Revista Olhar Científico, um evento marcante ocorrido em uma data específica não fornecida, a comunidade acadêmica se reuniu para celebrar a inauguração desta importante plataforma de divulgação científica. '
  },
  {
    id: 9,
    link: '#',
    image: require('../../../assets/Not_08.jpg'),
    title: 'Batismo dos Caloiros ISPA 2023',
    subtitle: 'No Batismo dos Caloiros do ISPA em 2023, os novos estudantes foram recebidos em uma atmosfera de camaradagem e tradição. O evento, realizado com entusiasmo pela comunidade acadêmica, incluiu rituais simbólicos e atividades de integração para dar as boas-vindas aos caloiros.'
  },

]
let active = 2;
let items = [];
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>,
  );
}
    return(
        <div className="App">
        <div className="banner position-relative" id="backImage">
            <div className="title-banner" id="banner">
            <h1 style={{color:'white'}}>Notícias e Atualizações</h1>
            <h3>Aqui você encontra as últimas informações, comunicados oficiais, eventos, conquistas,<br /> e tudo o que está acontecendo na nossa instituição.<br /> </h3>
            </div>
        </div>
        <header id='header'>    
        <AppHeader />
        </header>
        <main>
          
    <section id="works" className="block works-block">
      <Container fluid>
        <div className="title-holder">
          <h2>Notícias em Destaque</h2>
          <div className="subtitle"> Fique por dentro das notícias mais recentes e relevantes</div>
        </div>
        <Row className='portfoliolist'>
          {
            NoticiaData.map(noticia => {
              return (
                <Col sm={4} key={noticia.id}>
                  <div className='portfolio-wrapper'>
                   <Link to={`/noticia/${noticia.id}`}>
                    <Image src={noticia.image} />
                    <div className='label text-center'>
                        <h3>{noticia.title}</h3>
                        <p style={{color:'#FFFFFF'}}>{noticia.subtitle}</p>
                    </div>
                    </Link>
                  </div>
                </Col>
              );
            })
          }
        </Row>
      </Container> 
      <br /> 
         <Container fluid>
        <div className="title-holder">
          <h2>Todas as Notícias</h2>
          <div className="subtitle">Veja o histórico completo de publicações e atualizações do nosso portal</div>
        </div>
        <Row className='portfoliolist'>
          {
            worksDataSecound.map(works => {
              return (
                <Col sm={4} key={works.id}>
                  <div className='portfolio-wrapper'>
                    <Link to={`/noticia/${works.id}`}>
                    <Image src={works.image} />
                    <div className='label text-center'>
                        <h3>{works.title}</h3>
                        <p style={{color:'#FFFFFF'}}>{works.subtitle}</p>
                    </div>
                    </Link>
                  </div>
                </Col>
              );
            })
          }
        </Row>
      </Container> 
    </section>
    </main>
    <AppLayout />
    </div>
    )
}